<template>
  <div id="resumesec2" ref="pdfContent">
    <div
      class="main-container cover-letter-2"
      style="
        border-collapse: collapse;
        display: table;
        min-height: inherit;
        table-layout: fixed;
        width: 100%;
        word-wrap: break-word;
        font-size: 16px;
        color: #000;
        line-height: 1.3;
        font-family: 'Montserrat', sans-serif;
      "
    >
    <div v-show="false" class="img-box" style="padding: 0">
        <div class="img-box">
          <img id="imgPreview" :src="temp_pic" alt />
        </div>
        <label
          style="
            padding: 7px 10px;
            border-radius: 5px;
            color: #fff;
            background-color: #6c757d;
            border-color: #6c757d;
          "
          class="btn-secondary"
          for="fileUpload"
          >Upload Image</label
        >
        <input
          style="display: none"
          type="file"
          name="fileUpload"
          @change="previewFiles"
          id="fileUpload"
          accept="image/*"
        />
      </div>
      <div
        class="left-container gray-bg"
        style="
          background: #4b505a;
          position: relative;
          box-sizing: initial;
          color: #fff;
          display: table-row;
          width: 100%;
          padding: 15px 0;
        "
      >
        <div
          class="highlight-sec"
          @mouseover="highlightItem('NameCon')"
          :class="{ highlighted: highlightedIndex === 'NameCon' }"
          @mouseout="unhighlightItem('NameCon')"
        >
          <div class="edit-box">
            <button
              v-show="highlightedIndex === 'NameCon'"
              @click="Edit('NameCon')"
            >
              <i class="material-icons">edit</i>
            </button>
          </div>
          <div class="relative">
            <div class="hover-heading">
              <div v-show="highlightedIndex === 'NameCon'" class="hover-sectiontitle">
                Name & Contact
              </div>
            </div>
            <div class="resume-block" style="padding: 15px 30px">
              <h1 style="font-size: 36px; font-weight: 700">{{ User_Name }}</h1>
            </div>

            <div class="resume-block" style="padding: 15px 30px">
              <p style="margin: 0 0 5px">
                <b style="font-weight: 600">Address: </b> {{ Address }}
              </p>
              <p style="margin: 0 0 5px">
                <b style="font-weight: 600">Email: </b>{{ Email }}
              </p>
              <p style="margin: 0 0 5px">
                <b style="font-weight: 600">Phone: </b>{{ PhoneNumber }}
              </p>
            </div>
          </div>
          <div class="doc-overlay"></div>
        </div>
      </div>

      <div class="right-container">
        <div>
          <div class="resume-block" style="padding: 15px 30px">
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Date')"
              :class="{ highlighted: highlightedIndex === 'Date' }"
              @mouseout="unhighlightItem('Date')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Date'"
                  @click="Edit('Date')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Date'"
                  @click="Delete('Date')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Date'"
                    class="hover-sectiontitle"
                  >
                    Date
                  </div>
                </div>
                <p style="margin-bottom: 20px">{{ Coverletterdate }}</p>
              </div>
              <div class="doc-overlay"></div>
            </div>
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Recipient')"
              :class="{ highlighted: highlightedIndex === 'Recipient' }"
              @mouseout="unhighlightItem('Recipient')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Recipient'"
                  @click="Edit('Recipient')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Recipient'"
                  @click="Delete('Recipient')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Recipient'"
                    class="hover-sectiontitle"
                  >
                    Recipient
                  </div>
                </div>
                <div>{{ Recipient_First_Name }} {{ Recipient_Last_Name }}</div>
                <div>
                  {{ Recipient_Company }}
                </div>
                <div>
                  {{ Recipient_Company_Address }}
                </div>
                <div>
                  {{ Recipient_PhoneNumber }}
                </div>
                <div>
                  {{ Recipient_Email }}
                </div>
              </div>
              <div class="doc-overlay"></div>
            </div>
          </div>
          <div class="resume-block" style="padding: 15px 30px">
            <div
              class="highlight-sec"
              @mouseover="highlightItem('subject')"
              :class="{ highlighted: highlightedIndex === 'subject' }"
              @mouseout="unhighlightItem('subject')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'subject'"
                  @click="Edit('Subject')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'subject'"
                  @click="Delete('Subject')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'subject'"
                    class="hover-sectiontitle"
                  >
                    Subject
                  </div>
                </div>
                <div v-html="subject"></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
            <br />
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Greeting')"
              :class="{ highlighted: highlightedIndex === 'Greeting' }"
              @mouseout="unhighlightItem('Greeting')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Greeting'"
                  @click="Edit('Greeting')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Greeting'"
                  @click="Delete('Greeting')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Greeting'"
                    class="hover-sectiontitle"
                  >
                    Greeting
                  </div>
                </div>
                <div v-html="greeting"></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
          </div>
          <div class="resume-block" style="padding: 15px 30px">
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Opening')"
              :class="{ highlighted: highlightedIndex === 'Opening' }"
              @mouseout="unhighlightItem('Opening')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Opening'"
                  @click="Edit('Opening')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Opening'"
                  @click="Delete('Opening')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Opening'"
                    class="hover-sectiontitle"
                  >
                    Opening
                  </div>
                </div>
                <div><p align="justify" v-html="opening"></p></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Body')"
              :class="{ highlighted: highlightedIndex === 'Body' }"
              @mouseout="unhighlightItem('Body')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Body'"
                  @click="Edit('Body')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Body'"
                  @click="Delete('Body')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Body'"
                    class="hover-sectiontitle"
                  >
                    Body
                  </div>
                </div>
                <div ><p align="justify" v-html="letterbody"></p></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Desc')"
              :class="{ highlighted: highlightedIndex === 'Desc' }"
              @mouseout="unhighlightItem('Desc')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Desc'"
                  @click="Edit('Desc')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Desc'"
                  @click="Delete('Desc')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Desc'"
                    class="hover-sectiontitle"
                  >
                    Description
                  </div>
                </div>
                <div ><p align="justify" v-html="formatText(desc)"></p></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Calltoaction')"
              :class="{ highlighted: highlightedIndex === 'Calltoaction' }"
              @mouseout="unhighlightItem('Calltoaction')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Calltoaction'"
                  @click="Edit('Calltoaction')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Calltoaction'"
                  @click="Delete('Calltoaction')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Calltoaction'"
                    class="hover-sectiontitle"
                  >
                    Calltoaction
                  </div>
                </div>
                <div ><p align="justify" v-html="calltoaction"></p></div></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
          </div>
          <div class="resume-block" style="padding: 15px 30px">
            <br />
            <div
              class="highlight-sec"
              @mouseover="highlightItem('Closing')"
              :class="{ highlighted: highlightedIndex === 'Closing' }"
              @mouseout="unhighlightItem('Closing')"
            >
              <div class="edit-box">
                <button
                  v-show="highlightedIndex === 'Closing'"
                  @click="Edit('Closing')"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="highlightedIndex === 'Closing'"
                  @click="Delete('Closing')"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
              <div class="relative">
                <div class="hover-heading">
                  <div
                    v-show="highlightedIndex === 'Closing'"
                    class="hover-sectiontitle"
                  >
                    Closing
                  </div>
                </div>
                <div v-html="closing"></div>
              </div>
              <div class="doc-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import moment from "moment";
export default {
  name: "CoverLetter_2",
  data() {
    return {
      temp_pic:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAATlBMVEX///+ZmZmWlpaQkJCUlJSbm5v4+PilpaXl5eXz8/O1tbWhoaH8/PzCwsLW1tapqanLy8vd3d2xsbHr6+vGxsbf39/Nzc3v7++6urqtra0jtpVVAAALJUlEQVR4nNVd27ajIAytqXhD0Wqt+v8/eqi21rsQQDj7adasGcoWEnIj3G6mETRRzYqsLbuQUkI8QigNu7LNClZHTWD89w0ijSv2THJKPOjhTfH5K0Lz5MmqOLU9WWkEFcs66q2IrdH/E9plrPpHy9mwNvT8U25znr4XtqyxPXUBBHVLfV+G3ISm79O2dnopY1YSqaXbWkxSstg2kW3ELKGK9L4kaeIeybRq9dAbSbaVS/o1ZR1S9A5I+h1zhWOTgXZ+A0fIXFCuUUJM0PuQJElkl14alZ45fj1Hr4wsbtYo0ahddjmCtXWsEiPit8HRTyoL/Lh+uYZfz/F6nRO86HX8eo70dak5F+XX8us55teJY3DlBp1QhOyiZWQGD8ATjoRdwC9ubfHrObbGTfJHaJMgpxg+jPJLn4ZNGAGK3tOgjRNbXsABEBrbqQ9rKmYOIGZ2Kt+h7sDETg0SNxZwACTaj0ZlEQTwff8+gP9J1WbQLoyRighycpC3BYs+oe00jljRhqBEE4hWI07FjAEvzx4bYfs0fmS5wuGj1cB5EfQ0IHwe+Ohp9AzxC0le2gj6aH7laQg7qEs0R18TxQJJEKAVc82rFsvRL3QQzJBJCGjF3fIGyxEyewRzObvjgfSp1SkWyP3zlD2RA6TJBIobFadkcGcV8sxVUzdIggnOakxxhqEKRYY7B9FmcfpEUcQf/RGOoIqpwVC/iDXgYpRc+Gq2FMPIBRCUGR6gvAlQNRYZ6ldDhDOFFHt1axi1UTHKDSX0oMNQfKF++Sn7Mw/Er3ADQ0dwIcWZUZKxmxijRiHUEz1JURpATttc8RsHuOD74oRQn8+NU6gSoogTwkQbwdsNp8iFRREXVyM6M9EVbp+Kigkqu6QrovAByuaHVmxwlBB4mvToF2mImYSYKghQ9raiOboGykD1iIj1hjtviWaCtxvqQ4sENSIUQS3m2hwo482DU0cqwEWEqP4agoCiGOZnM0F+OQ1BvRVw4nK2mxrUh/M8E6UuEW4q9DhMi/xuuYnUeooTmOP9VCHDstLOmRBwcSkPjowrZJ73XIGhgFPrhwZyhMzBYKIkAghQdg23PnY/ODI0o9ermAI9nz21gNwVyqmDXWCTJrtSU2KzeKbKIrFSA+XOeLjhOENTRZEBNvm8cz6jC2aIsUIzbP3AtmZo0MPlpgje0KXIZMuwQSZ7DapShW21Zdik6KIPI2b3APRX92AtOTifuh/MjM32BtJu87ZiDmmH/1z6vd8vcL5cP6luuYgVegl1R9lmDBVmtbS/FerT3WS4jCzGSM+3H8vFXco94Xl4GBcj/TB0UdOsYqcqBcBOnhbLY1plkzp54r8x26Yqm9RJq62f13SbYv2mAe5Z3gPDiQ+FS1WMcNB76jFJYtRqhfPOecAfQD2OpHgdzbkoxndev0NfRZN67kWiRtDvQI3aZnAumjjC//rBeMfpA7ciwhOG3/NC+VaoW1H9ybw+gqi8GdzKzEzxEZ9KdRzPqezaDIOTqCyGTmVIZ/gIooaR3MlyzzF8eYUIzWQoVyoVFtPqozVKntMIR6pNlug9KB2KxpmKoRXeqkbJN/zBiaqvFXofUflcHeBC5d4avS2i6462/erLDfROga5WMw5U0G5MKtdz7HxGs1wFvQl+UKPThmvYrWTfmVOjxfr7wO5thB1EqjGaGazeKNmZUq1xy3s2bwXtzoipRnuWsHSzaxdQaPEspiNauZ13MJ9MPYSxgI0blgeAVjGgv4Xrb8keAMpbp3tMbgtefNP5EN1Njw0/w8W31Y8Rqsa7N3Fpx4ETUCMMvQu7RpyB6gkWrHFV549TEFMML+recg5yMzSwd0kHHhEYW8M3THdREoG5XTrAaCcsIRBTuvQHU93MBGHstJji3ZEu1N2RThTUhE2zCc1dBYURGrBL3UJnwLdwCty3sNr42Dy4f6jZx3cN3MfXHKdxDVDojou4BmBa46UOAmqdMe/3gO9j747H+6DU+8kjjXkLTo7k7avGvxOXxlX9anOi0R4gjbbc09v8jLS8gceNOn0G67tIRIdzfeJCIFhWepyOvkJbPcAF0DED9TSsU+fYp21VY5Tgd8ZqhJWfAuvz+IoHIuT16UzxqBVlqE+jKNXTACnMvowSvNSiqO9IkdKVp9D8Q0yVSka4r4lSqGvz2yseDEtb/OXP4RYi1rsADelQMTDs6fipCkWm7DS37j8ENqXxSWbiVA3QK99Cq5BPhA1zRNV5X0sQS/F7TQIRyACtVWxCFBEbdbw0gxHE658kRLh5Y02B/J0Z7fWyIpBfiPHOjHTcW7QDo2ZISxPF/ldd9WuykK13myyEZKzmci3zhWRd7eT+odwdUmPXDc8hF/qcNsKUCe2fdyY0B6mujrNeSjI+om/SHzxDLaFPZyV2Eh4UdNbovSHhCM3bRogHawzdphSF+K3LRWW98DY12F5ADMKLuKgDFd6mGgvycRBei0VvE+FD39ClZnGIekIru0uwx5DBTi2iEIx+rnoMiUZrbJkzP4j5GOs+UWKWu5krzXIQuwC94f0I9Wsz2GxHHEKRs41+bUL/0ViPDxmI2DWbSyGUSDT+ZrQAYoF5bvZNFLBrNsTXAgSU4s5NwXMlZcm3X0Lg7N6RplMfymBnNhmcXoza60F7btVadZx+OFU1u97B6X2HlZ1gB2f218F9j7O+THcXVClXpveThTg4004W8e6CKuV77Zjh4ZXrk77698tIHOOE4aEsHRs2/4LhiWV5/L7Fv2B48r7F8VnzHxientmHEcl/wFAgmnt07P8HhgLez4GycZ+hkAN7kMRwn6HQm10H8TrnGYrGOne9E9cZCnt3u+8fOs5Q/P3D3TcsHWco85zsTtTVbYZS0eqdjLnTDCWrC7a7/DjNULbD0aYoOs1Q8k3nbVF0mCEiZbQVtHGXIaoVR7DWNs4yBFxaM15VA7rKELB91KKlQnWVIb5amZF/wZAo1BYsOlC6yVCt6+acopMMVduKzmrlXGSoXkc4DWo4yFBH3n1C0T2GegoLCt9Zhr6mUtdR3VgpYF9jLIzR17v4RcZNYbvoi1uTo9gQjSlp9jXgoBRvb2UGzTcXDyoH/Rrj1Sog0n6YVjx+E9Fc2/OLv91bi3Xe7VfJSMTVhAcf/UUIbRUs1ONnhsTAZ07Htn9ArCicIPu5c+j2mscYZcDzLSxjHfrjFzamC37CCH57bV1G3Po/KTH403ynjr/jFddVZqTF5HcN7dAvHr/oDeSPazimk8aYEBo/reJfZgqgvKLeNJo0VoRLhIP9VBoXR9M2TvMTQN1mzD64ZTjhmJhcxyiZ8LvSKo4mFRvglVpb0/yQRuWk1QDkl5ZgBy8642ikP82MH31dbWU0k6367jH00qsC4lc4Gz+z4dNUybQ/jg+JPj3+SGAS5OOybquwNUqmfY6A26saJDKNuP05G9aoLjudTTlrO9I3/FKRl2DZ5sucHhNGlMwSODA01UUNNbTdnY1GbK7fCK5z/DlJn5SF7Myiolx0ouOjWtEvW0jZsikXZ3nPn49KZIOl1eOZ35d99sDvmBtF1wPSqqXL7mrvDoi0y1jd7LTiS+OmZllHvVWvRADaCn2dSxGzZEWypwkk7JKsYI+oapo4jpumih6syJIuJLDRCJLTS5gbtwJWiFlJNvvkQd8Tk+9kQighXv/n7SaX/HuUrtIbENQt9ZGd8jhx2p62qXcBDWtDT65DJ19iL2yZK6pTAEH1VSGnt7C+Cqn6D4s3RxpX7JnklPQslofB8FeE5smT4Xu6OoGgiWquOduyC+lbzXBlQ8OubLl2raPG/ML9AWeBpRLXHWJQAAAAAElFTkSuQmCC",
      highlightedIndex: "",
      User_Name: "First Name Last Name",
      First_Name: "",
      Last_Name: "",
      Coverletterdate: moment().format("MMMM DD, YYYY"),
      Address: "City , State, Pincode",
      Email: "",
      PhoneNumber: "",
      Recipient_First_Name: "First Name",
      Recipient_Last_Name: "Last Name",
      Recipient_Company: "Company Name",
      Recipient_City: "City Name",
      Recipient_State: "State",
      Recipient_Zip: "Pincode",
      Recipient_PhoneNumber: "Phone Number",
      Recipient_Email: "Email",
      Recipient_Company_Address: "State, City, Pincode",
      subject: "RE: Team Leader,[Ref#], [Date]",
      greeting: "Dear [Ms. or Mr. Last Name],",
      opening:
        "I am writing in regards to the open position for None. I am excited to apply and believe that my skills and experience make me the perfect candidate for the job. I look forward to discussing my qualifications further with you.",
      letterbody:
        "I am writing in response to your job posting for a [position]. I am confident that I have the skills and experience necessary for the role and would be a valuable asset to your team." +
        "I have experience in customer service and I am a fast learner. I am available to work on weekends and I am a reliable person. I am interested in this job and I would like to learn more about the company." +
        "I am excited to apply for the None position. I am a hard worker with a gogetter attitude. I have a passion for helping others and I am excited to help None." +
        "I have experience in customer service and I am a quick learner. I am interested in this position and I believe I would be a good fit for the company. I am excited to learn new things and I am willing to work hard.",
      desc: "",
      closing:
        "Sincerely, Thank you for your time, I look forward to hearing from you.",
      calltoaction:
        "I am a recent graduate of XYZ University and I am interested in obtaining a position in your company. I am a hard worker with a gogetter attitude. I have experience in customer service and I am a team player.",
    };
  },
  methods: {
    previewFiles(event) {
      debugger;
      this.isCorrupt = true;
      var self = this;
      var fileIn = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.onload = () => {
        const image = new Image();

        image.onerror = () => {
          // Image failed to load or is corrupted
          console.log("The selected image is corrupted.");
          self.isCorrupt = false;
          $("#fileUpload").val("");
          return prevent();
          //alert("corrupted");
        };

        image.onload = () => {
          // Image loaded successfully
          console.log("The selected image is valid.");
        };

        image.src = fileReader.result;
      };

      fileReader.readAsDataURL(fileIn);
      self.validateFile();
      if (self.isCorrupt) {
        var file = event.target.files[0];
        if (file) {
          let reader = new FileReader();
          reader.onload = function (event) {
            $("#imgPreview").attr("src", event.target.result);
          };
          reader.readAsDataURL(file);
        }
      }
    },
    Profilepicbind(val) {
      this.$parent.Profilepicbinding(val);
    },
    Getprofilepic() {
      var updatedFile = $("#imgPreview").prop("src");
      if (updatedFile != undefined) {
        this.temp_pic = updatedFile;
        let base64encoded = updatedFile.toString();
        const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
        base64encoded = base64encoded.substring(sIndex);
        return base64encoded;
      } else {
        return "";
      }
    },
    validateFile() {
      var fileName = document.getElementById("fileUpload").value;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("fileUpload").files;
      if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(fileName)) {
        $("#fileUpload").val("");
        return prevent();
      }
      //alert(this.fileCount > this.$store.state.helper.allowedFileSize? "larger":"smaller");
    },
    formatText(text) {
      // Split the text into paragraphs based on "\n\n" characters
      const paragraphs = text.split('\n\n');
      // Wrap each paragraph in <p> tags and join them
      return paragraphs.map(paragraph => `<p align="justify">${paragraph}</p>`).join('');
    },
    extractText(html) {
      debugger;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      // const formattedHTML = tempDiv.textContent;
      const formattedHTML = tempDiv.innerHTML;
      return formattedHTML;
    },
    Bindfortemplates(resumeobj) {
      var self = this;
      if (resumeobj.User_Profile.First_Name != "") {
        self.User_Name =
          resumeobj.User_Profile.First_Name +
          " " +
          resumeobj.User_Profile.Last_Name;
      } else {
        self.User_Name = "First Name Last Name";
      }
      self.First_Name = resumeobj.User_Profile.First_Name;
      self.Last_Name = resumeobj.User_Profile.Last_Name;
      self.Coverletterdate = resumeobj.coverletterdate;
      self.Email = resumeobj.User_Profile.Email;
      self.PhoneNumber = resumeobj.User_Profile.PhoneNumber;
      //profile address
      if (
        resumeobj.User_Profile.City != undefined &&
        resumeobj.User_Profile.City != ""
      ) {
        self.Address = resumeobj.User_Profile.City;
      }
      if (
        resumeobj.User_Profile.State != undefined &&
        resumeobj.User_Profile.State != ""
      ) {
        if (self.Address != "") {
          self.Address = self.Address + ", " + resumeobj.User_Profile.State;
        } else {
          self.Address = resumeobj.User_Profile.State;
        }
      }
      if (
        resumeobj.User_Profile.Zip != undefined &&
        resumeobj.User_Profile.Zip != ""
      ) {
        if (self.Address != "") {
          self.Address = self.Address + ", " + resumeobj.User_Profile.Zip;
        } else {
          self.Address = resumeobj.User_Profile.Zip;
        }
      }
      if (resumeobj.profilepicurl != "" && resumeobj.profilepicurl != null) {
        self.temp_pic = resumeobj.profilepicurl;
      }
      //Company Information

      if (
        resumeobj.Recipient_Details != null &&
        resumeobj.Recipient_Details != undefined
      ) {
        var Recipient_Details = resumeobj.Recipient_Details;
        self.Recipient_First_Name = Recipient_Details.Recipient_First_Name;
        self.Recipient_Last_Name = Recipient_Details.Recipient_Last_Name;
        self.Recipient_Company = Recipient_Details.Recipient_Company;
        self.Recipient_PhoneNumber = Recipient_Details.Recipient_PhoneNumber;
        self.Recipient_Email = Recipient_Details.Recipient_Email;
        if (
          Recipient_Details.Recipient_City != undefined &&
          Recipient_Details.Recipient_City != ""
        ) {
          self.Recipient_Company_Address = Recipient_Details.Recipient_City;
        }
        if (
          Recipient_Details.Recipient_State != undefined &&
          Recipient_Details.Recipient_State != ""
        ) {
          if (self.Recipient_Company_Address != "") {
            self.Recipient_Company_Address =
              self.Recipient_Company_Address +
              ", " +
              Recipient_Details.Recipient_State;
          } else {
            self.Recipient_Company_Address = Recipient_Details.Recipient_State;
          }
        }
        if (
          Recipient_Details.Recipient_Zip != undefined &&
          Recipient_Details.Recipient_Zip != ""
        ) {
          if (self.Recipient_Company_Address != "") {
            self.Recipient_Company_Address =
              self.Recipient_Company_Address +
              ", " +
              Recipient_Details.Recipient_Zip;
          } else {
            self.Recipient_Company_Address = Recipient_Details.Recipient_Zip;
          }
        }
        if (
          Recipient_Details.Recipient_Zip == "" &&
          Recipient_Details.Recipient_State == "" &&
          Recipient_Details.Recipient_City == ""
        ) {
          self.Recipient_Company_Address = "";
        }
      }

      //Subject
      if (resumeobj.subject != null && resumeobj.subject != undefined) {
        self.subject = resumeobj.subject;
      }
      //Greeting
      if (resumeobj.greeting != null && resumeobj.greeting != undefined) {
        self.greeting = resumeobj.greeting;
      }

      //Opening
      if (resumeobj.opening != null && resumeobj.opening != undefined) {
        self.opening = resumeobj.opening;
      }
      //Body
      if (resumeobj.letterbody != null && resumeobj.letterbody != undefined) {
        self.letterbody = resumeobj.letterbody;
      }
      //Desc
      if (
        resumeobj.jobdescription != null &&
        resumeobj.jobdescription != undefined
      ) {
        self.desc = resumeobj.jobdescription;
      }

      //Call to Action
      if (
        resumeobj.calltoaction != null &&
        resumeobj.calltoaction != undefined
      ) {
        self.calltoaction = resumeobj.calltoaction;
      }
      //Closing
      if (resumeobj.closing != null && resumeobj.closing != undefined) {
        self.closing = resumeobj.closing;
      }
    },
    highlightItem(index) {
      this.highlightedIndex = index;
    },
    unhighlightItem(index) {
      this.highlightedIndex = "";
    },
    Edit(val) {
      this.$parent.EditPopup(val);
    },
    Delete(val) {
      this.$parent.Delete(val);
    },
    GetContent() {
      const pdfContent =
        "<!DOCTYPE html><html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'/><style type='text/css' id='static'>@font-face { font-family: 'Century Gothic'; font-weight: normal; font-style: normal; src: local('Century Gothic'), url('/blobcontent/zty/fonts/CenturyGothic.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: bold; font-style: normal; src: local('Century Gothic Bold'), url('/blobcontent/zty/fonts/CenturyGothicBold.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: bold; font-style: italic; src: local('Century Gothic Bold Italic'), url('/blobcontent/zty/fonts/CenturyGothicBoldItalic.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: normal; font-style: italic; src: local('Century Gothic Italic'), url('/blobcontent/zty/fonts/CenturyGothicItalic.ttf') format('truetype'); } html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td { margin: 0; padding: 0; border: 0; outline: 0; vertical-align: baseline; background: transparent; } body { text-align: left; font-feature-settings: 'liga' 0; -moz-font-feature-settings: 'liga' off; } .skn-srz5 ol, .skn-srz5 ul { list-style: none; } .skn-srz5 table { border-collapse: collapse; border-spacing: 0; font-size: inherit; color: inherit; width: 100%; } /*START content disc style for LI*/ .skn-srz5 ul, .skn-srz5 li { margin: 0; padding: 0; list-style-type: disc; } .skn-srz5 ul li { margin: 0 0 0 16px; padding: 0; } @-moz-document url-prefix() { .skn-srz5 ul li { margin: 0 0 0 12px; padding: 0 0 0 3px; } } /*END content disc style for LI*/ .skn-srz5 span.paddedline { display: block; } .skn-srz5 span.jobtitle, .skn-srz5 span.degree, .skn-srz5 span.programline { font-weight: bold; } .skn-srz5 .pb5 { padding-bottom: 5px; } .skn-srz5 span.dates_wrapper { font-weight: bold; display: block; float: left; text-align: left; padding-right: 10px; box-sizing: border-box; } .skn-srz5 .txtItalics { font-style: italic; } .skn-srz5 .txtBold { font-weight: bold; } /*table style*/ .skn-srz5 table.skills, .table_wrapper { width: 100%; margin-top: 0; word-wrap: break-word; } .skn-srz5 table.skills th, table.skills td { width: 20%; text-align: center; } .skn-srz5 table.skills .skillname, .skn-srz5 table.skills .skillrating { text-align: left; width: 35%; } .skn-srz5 table.skills .skillrating { width: 20%; } .skn-srz5 table.skills .skillyears, .skn-srz5 table.skills .skilllast { width: 19%; } .skn-srz5 table.skills .pad1 { width: 5%; } .skn-srz5 .skills .pad2, .skn-srz5 table.skills .pad3 { width: 1%; } /*document*/ .skn-srz5 { box-sizing: border-box; color: #343434; font-variant-ligatures: none; line-height: 16px; padding-bottom: 24px; min-height: 792px; position: relative; word-wrap: break-word; } .skn-srz5 .topbgborder { bottom: -6px; height: 14px; left: 16px; position: absolute; width: 26px; } .skn-srz5 .nameSec { padding-top: 24px !important; } .skn-srz5 .nameSec .paragraph, .skn-srz5 .cntcSec .paragraph, .skn-srz5 .summary .paragraph { padding: 0; } .skn-srz5 .name { color: #fff; font-weight: 700; text-align: left; word-wrap: break-word; } .skn-srz5 .address { color: #fff; text-align: left; font-size: 0.917em; line-height: 1.25em; margin-top: 0; white-space: nowrap; position: relative; z-index: 2; } .skn-srz5 .address .txtBold { margin-right: 3px; } .skn-srz5 .addressLeft, .skn-srz5 .addressRight { width: 49%; padding: 0 1% 0 0; white-space: normal; display: inline-block; vertical-align: top; } .skn-srz5 .addressRight { padding: 0 0 0 1%; } .skn-srz5 .sectiontitle { word-wrap: break-word; } .skn-srz5 .degreeGap { margin-bottom: 4px; } .skn-srz5 .locationGap { margin-top: 4px; } .skn-srz5 .firstsection, .skn-srz5 .nameSec, .skn-srz5 .cntcSec { padding-top: 0 !important; } .skn-srz5 .education .joblocation { font-style: italic; } .skn-srz5 .resumeTitle { text-align: left; color: #fff !important; z-index: 2; position: relative; font-weight: 400; } /*leftBox and rightBox css*/ .skn-srz5 .left-box .sectiontitle { text-align: left; } /* fixes for grey border */ .skn-srz5 .left-box .section { position: relative; } .skn-srz5 .right-box { display: table-cell; letter-spacing: 0.2px; vertical-align: top; } .skn-srz5 .right-box .section { border-left: 1px solid #d5d6d6; padding-left: 23px; position: relative; } .skn-srz5 .right-box .section:first-child { padding-top: 0; } .skn-srz5 .parentContainer .section { border-left: 1px solid #d7d7d7; padding-left: 24px; padding-right: 24px; margin-left: 12px; position: relative; } .skn-srz5 .parentContainer .summary { padding-left: 0; padding-right: 0; border: none; } .skn-srz5 .heading { clear: both; color: #373d48; font-weight: bold; } /*topsection css*/ .skn-srz5 .topsection { background: #373d48; display: flex; flex-wrap: wrap; } .skn-srz5 .left-box, .skn-srz5 .right-box { display: table-cell; padding-top: 24px; padding-bottom: 15px; } .skn-srz5 .left-box { box-sizing: initial; display: table-cell; position: relative; width: 100%; } .skn-srz5 .left-box { width: 70%; flex-grow: 1; } .skn-srz5 .right-box { padding-left: 0; } .skn-srz5 .right-box .section { border: 0; padding-left: 0; } .skn-srz5 .right-box .section .icon-heading, .skn-srz5 .right-box .section:first-child .icon-heading { height: 25px; left: -8px; position: absolute; top: 3px; width: 25px; z-index: 10; } /*.skn-srz5 .icon1{opacity:.75}*/ .skn-srz5 .right-box .section .icon-heading { top: 23px; } .skn-srz5 .right-box .paddedline.date-content { position: absolute; font-weight: 700; margin-left: 0; width: 65px; } .skn-srz5 .paragraph { position: relative; clear: both; } .skn-srz5 .paragraph .singlecolumn { position: relative; } .skn-srz5 .section:empty, .skn-srz5 .hide-bar .ratingRect .noLnht, .skn-srz5 .hide-bar .field-ratt { display: none; } .skn-srz5 .right-box .education .paragraph, .skn-srz5 .right-box .experience .paragraph, .skn-srz5 .right-box .summary .paragraph { margin-left: 0; } .skn-srz5 .right-box .summary .singlecolumn { margin-left: 0 !important; } /*Timeline classes*/ .skn-srz5 .summary { border: none; margin-left: 0; padding-left: 0; padding-top: 20px !important; } .skn-srz5 .firstsection, .skn-srz5 .cntcSec { border: none; } .skn-srz5 .firstsection { padding-bottom: 0; } .skn-srz5 .heading, .skn-srz5 .singlecolumn { position: relative; } .skn-srz5 .singlecolumn:before { display: block; position: absolute; top: 0; left: -30px; content: ''; height: 9px; width: 9px; border: 0; background: #373d48; z-index: 2; transform: rotate(45deg); } .skn-srz5 .summary .singlecolumn:before { display: none; } .skn-srz5 .section.notdraggable + .section:not(.notdraggable):before { border: 3px solid #fff; content: ''; position: absolute; top: 0; left: -2px; } .skn-srz5 .paragraph + tr.paragraph:before { display: none; } .skn-srz5 .notdraggable { border: 0; } /*Icon*/ .skn-srz5 .headingIcon { left: -45px; top: -7px; position: absolute; } .skn-srz5 .headingIcon svg { height: 40px; width: 40px; position: relative; } .skn-srz5 .headingIcon svg rect { transform: rotate(45deg); fill: #373d48; } .skn-srz5 .headingIcon svg path { fill: #fff; } .skn-srz5 .ratingRect { float: right; text-align: right; } .skn-srz5 .ratingRect .noLnht { line-height: 0; } .skn-srz5 .ratingRect svg rect { transform: rotate(45deg); } .skn-srz5 .ratingfield p { display: inline; } /*common css*/ .skn-srz5 .txtBold { font-weight: bold; } .skn-srz5 .txtItl { font-style: italic; } .skn-srz5 .paddedline { display: block; } .skn-srz5 .pt5 { padding-top: 5px; } .skn-srz5 .word-break { word-wrap: break-word; } .skn-srz5 .noPind { margin-left: 0 !important; } /* Issues fix for builder page */ #displayResume .skn-srz5.document { min-height: 792px; } /* finalize page Timeline */ .skn-srz5 > div:not(.topsection), .skn-srz5 > div:not(.parentContainer) { min-height: auto; } .skn-srz5 .rating .default-fill { fill: #003d73; } .skn-srz5 .sortable-item .rating-wrapper { display: block; } /*.skn-srz5 .sortable-item .rating-wrapper > div{display:flex;position:relative;white-space:nowrap}*/ /*PICT*/ .skn-srz5 .prflPic, .skn-srz5 .prflPic > div { float: right; width: 124px; height: 124px; } .skn-srz5 .prflPic img { min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; }</style><style> .skn-srz5, .skn-srz5 table { line-height: 16px; } .skn-srz5.pagesize { width: 825px; } .skn-srz5.fontface { font-family: Century Gothic; } .skn-srz5.fontsize { font-size: 11px; } .skn-srz5 .topsection { background: #373d48; } .skn-srz5 .section { padding-top: 20px; } .skn-srz5 .heading { padding-bottom: 10px; color: #373d48; } .skn-srz5 .jobtitle, span.degree, span.programline { font-size: 14px; } .skn-srz5 .paragraph { padding-top: 10px; } .skn-srz5 .firstparagraph { padding-top: 10px; } .skn-srz5 .photo .paragraph { padding-top: 0; } .skn-srz5 .firstparagraph .singlecolumn.maincolumn, .skn-srz5 .singlecolumn.paragraphindent { margin-left: 0; } .skn-srz5 .singlecolumn, .skn-srz5 .maincolumn { margin-left: 70px; } .skn-srz5 span.dates_wrapper { width: 70px; font-size: 11px; line-height: 17px; } .skn-srz5 .sectiontitle, .skn-srz5 .resumeTitle { font-size: 16px; line-height: 21px; } .skn-srz5 table.skills td { padding-top: 5px; } .skn-srz5 .name { font-size: 36px; line-height: 46px; } .skn-srz5 .sectiontitle { font-size: 16px; } .skn-srz5 .right-box .paragraph .singlecolumn { margin-left: 20px; } .skn-srz5 .right-box .paddedline.date-content { left: -20px; } .skn-srz5 .rating-wrapper { margin-top: 5px; } .skn-srz5 .rating-wrapper * { font-size: 11px; } .skn-srz5 .sectiontitle, .skn-srz5 .resumeTitle { font-size: 16px; line-height: 21px; } .skn-srz5 .parentContainer, .skn-srz5 .topsection { padding-left: 24px; padding-right: 24px; } .skn-srz5 .parentContainer svg.rating { padding-top: 20px; } .skn-srz5 .address { font-size: 11px; line-height: 21px; padding-top: 10px; } /*Timeline*/ .skn-srz5 .section.notdraggable + .section:not(.notdraggable):before { height: 30px; } .skn-srz5 .singlecolumn:before { background: #373d48; top: 4px; } .skn-srz5 .paragraph .dates_wrapper + .singlecolumn:before { left: -100px; } /*Icon*/ .skn-srz5 .headingIcon svg rect { fill: #373d48; } .skn-srz5 .headingIcon { top: -8px; } </style></head><body>" +
        document.getElementById("resumesec2").outerHTML +
        "</body></html>";
      console.log(pdfContent);
      return pdfContent;
    },
  },
};
</script>
<style type="text/css" scoped>
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
/* End reset styles */

body {
  font-size: 16px;
  color: #000;
  line-height: 1.3;
  font-family: "Montserrat", sans-serif;
}

.gray-bg {
  background: #4b505a;
}
.template {
  position: relative;
}
.template:before {
  background: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  opacity: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  -webkit-transition: all ease 0.5s;
  -moz-transition: all ease 0.5s;
  -o-transition: all ease 0.5s;
  transition: all ease 0.5s;
  z-index: 1;
}
button.btn-select-template {
  height: 45px;
  width: 214px;
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: #1f85cd;
  border-color: rgba(0, 0, 0, 0);
  border-radius: 0;
  min-width: 180px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
button.btn-select-template:hover {
  background-color: #10619b;
}
.template:hover:before {
  opacity: 1;
}
.template:hover button.btn-select-template {
  opacity: 1;
}
.main-container {
  border-collapse: collapse;
  display: table;
  min-height: inherit;
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
}
.left-container {
  display: table-cell;
  padding: 15px;
  position: relative;
  box-sizing: initial;
  color: #fff;
  width: 154px;
}
.right-container {
  display: table-cell;
  letter-spacing: 0.2px;
  padding: 15px;
  vertical-align: top;
}

.resume-block {
  padding: 15px 0;
}
.resume-block h1 {
  font-size: 36px;
  font-weight: 700;
}
.resume-block p {
  margin-bottom: 20px;
}
.resume-block span {
  color: blue;
}

b {
  font-weight: 600;
}

.cover-letter-2 {
  display: table;
}
.cover-letter-2 .left-container {
  width: 100%;
  padding: 15px 0;
  display: table-row;
}
.cover-letter-2 .left-container .resume-block p {
  margin: 0 0 5px;
}
.cover-letter-2 .right-container {
  width: 100%;
  padding: 15px 0;
  display: table-row;
}
.cover-letter-2 .resume-block {
  padding: 15px 30px;
}
</style>